// Field IDs for header fields
export const HEADER_FIELD_IDS = {
  MEMBER_ID: '360049040451',
  CLIENT: '10317751120532',
  PROVIDER: '7493324194836',
  VISIT_ID: '360049386912',
}

// Header fields array for display
export const HEADER_FIELDS = [
  HEADER_FIELD_IDS.MEMBER_ID,
  HEADER_FIELD_IDS.CLIENT,
  HEADER_FIELD_IDS.PROVIDER,
  HEADER_FIELD_IDS.VISIT_ID,
]

// Field IDs for crisis note fields that need special handling
export const SPECIAL_FIELD_IDS = {
  CSSRS_COMPLETED: '30644693646484',
  CRISIS_INTERVENTIONS: '9393534266260',
  MEMBER_FIRST_CALLED: '9393225441428',
  MEMBER_SECOND_CALLED: '9569943561364',
  MEMBER_THIRD_CALLED: '9569930586132',
  EMERGENCY_SERVICES_CONTACT_TIME: '31329232196628',
  EMERGENCY_SERVICES_ARRIVAL_TIME: '31329029918100',
}

// Category field ID that should span both columns
export const CATEGORY_FIELD_ID = '30632781111700'

// Ordered list of field IDs to maintain specific design requirements
export const ORDERED_FIELD_IDS = [
  CATEGORY_FIELD_ID, // Category
  '35960666549524', // Crisis - Visit Related?*
  '360035371211', // Service Line
  '30342725456788', // Crisis Entry Point
  '30644424393236', // CRT made contact with member
  SPECIAL_FIELD_IDS.CSSRS_COMPLETED, // If CRT contacted member, C-SSRS must be completed
  '22692802552852', // Crisis Acuity
  '30644775435796', // Were Emergency Services Activated for the member
  SPECIAL_FIELD_IDS.EMERGENCY_SERVICES_CONTACT_TIME, // If emergency services were activated, what time were emergency services contacted
  SPECIAL_FIELD_IDS.EMERGENCY_SERVICES_ARRIVAL_TIME, // If emergency services were activated, what time did emergency services arrive
  '30644908276628', // If emergency services were activated, document name/credentials
  '30644959141012', // If a police report was generated, document number
  '30645066101140', // Was the member transported to a hospital
  '30645129014164', // Was the member admitted
  '30645133077524', // Is the member part of faculty/staff
  '30645630532628', // Was School Notified - Enrolled Students ONLY
  '30645720102420', // Was School Notified - If YES, who was contacted
  '30645751176724', // Was School Notified - If YES, Method of Notification
  SPECIAL_FIELD_IDS.CRISIS_INTERVENTIONS, // Crisis - Interventions performed
  '35669279726996', // Crisis - C-SSRS Post Visit Follow Up Survey (see macro)*
  SPECIAL_FIELD_IDS.MEMBER_FIRST_CALLED, // Member First Called Date
  SPECIAL_FIELD_IDS.MEMBER_SECOND_CALLED, // Member Second Called Date
  SPECIAL_FIELD_IDS.MEMBER_THIRD_CALLED, // Member Third Called Date
]
